/**
 * @author evdokimov
 */
import BillingSummaryCSVPreviewGenerator from './preview/csv/billingsummary/BillingSummaryCSVPreviewGenerator'
import OldBaseFormMediator from './OldBaseFormMediator'
import BillingSummaryReportEditFormConfigController from './edit_config_controller/BillingSummaryReportEditFormConfigController'
import BillingSummaryHTMLPreviewGenerator from './preview/html/billingsummary/BillingSummaryHTMLPreviewGenerator'
import ATReportParamsStringBuilder from './reportParamsStringBuilder/ATReportParamsStringBuilder'

export default function BillingSummaryFormMediator () {}

BillingSummaryFormMediator.prototype = new OldBaseFormMediator();

BillingSummaryFormMediator.prototype.init = function ( config ) {
    OldBaseFormMediator.prototype.init.call(this, config);

    return this;
};

BillingSummaryFormMediator.prototype.initParamsStringBuilder = function(config) {
    return new ATReportParamsStringBuilder(
        {
            data: {
                cpList: config.cpList,
                manageableUsersIds: ATReportsStore.getManageableUserIds(),
                projectsWithMaIds: ATReportsStore.getProjectsWithMaIds(),
            },
            reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
        })
}

BillingSummaryFormMediator.prototype.initEditConfigController = function ( config ) {
    return new BillingSummaryReportEditFormConfigController().init(
        {
            panelId: "mainContainer",
            reportParameters: config.reportParameters,
            reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
            cpList: config.cpList,
            customersWithMaIds: config.customersWithMaIds,
            projectsWithMaIds: config.projectsWithMaIds,
            changeCallback: () => this.changeParametersCallback(),
        }
    )
}

BillingSummaryFormMediator.prototype.initCsvGenerator = function()
{
    return new BillingSummaryCSVPreviewGenerator().init();
};

BillingSummaryFormMediator.prototype.initHtmlGenerator = function(){
    return new BillingSummaryHTMLPreviewGenerator().init();
};




// WEBPACK FOOTER //
// ./web/js/reports/BillingSummaryFormMediator.js